import { parse } from 'date-fns';
import { IGerarRetornoAilos, IDocumentoRetornoAilos } from './types';
import { agruparRetorno } from '@/utils/agruparRetorno';

export function gerarRetorno({ dados }: IGerarRetornoAilos){
  try {
    const { arquivo } = dados;
    const documentos: IDocumentoRetornoAilos[] = [];

    let index = 0;

    for (const item of arquivo) {
      let linha = item;

      const banco = linha.substring(0, 3);
      const codigoRetorno = linha.substring(15, 17);

      if (
        (banco === '001' || banco === '085') &&
        (codigoRetorno === '06' || codigoRetorno === '17')
      ) {
        let segmento = linha.substring(13, 14);

        if (segmento === 'T') {
          const linhaDoc = linha.substring(105, 130).trimEnd();

          let tipoDocumento: string = 'INDEFINIDO';
          let idDocumento: string = linhaDoc;

          if (linhaDoc.includes('-')) {
            const [tipoDoc, idDoc] = linhaDoc.split('-');
            tipoDocumento = tipoDoc;
            idDocumento = idDoc;
          }

          const especie = tipoDocumento.length ? tipoDocumento : 'INDEFINIDO';

          linha = arquivo[index + 1];
          segmento = linha.substring(13, 14);

          if (segmento === 'U') {
            let dataCredito: Date;
            const dataCreditoString = linha.substring(145, 153);
            if (dataCreditoString && dataCreditoString !== '00000000') {
              dataCredito = parse(dataCreditoString, 'ddMMyyyy', new Date());
            } else {
              const dataOcorrenciaString = linha.substring(157, 165);
              dataCredito = parse(dataOcorrenciaString, 'ddMMyyyy', new Date());
            }

            const valorAbatimentoString = linha.substring(47, 62);
            const valorAbatimento = Number(valorAbatimentoString) / 100;

            const valorDescontoString = linha.substring(32, 47);
            const valorDesconto = Number(valorDescontoString) / 100;

            const valorPagoString = linha.substring(77, 92);
            const valorPago = Number(valorPagoString) / 100;

            const valorJurosString = linha.substring(17, 32);
            const valorJuros = Number(valorJurosString) / 100;

            const valorMulta = 0;
            const descontos = valorAbatimento + valorDesconto;
            const valorTotal = valorPago - valorJuros + descontos;

            const documento = {
              id_documento: idDocumento,
              especie,
              valor: valorPago,
              valor_multa: valorMulta,
              valor_juros: valorJuros,
              valor_desconto: valorDesconto,
              valor_total: valorTotal,
              data: dataCredito,
            };

            documentos.push(documento);
          }
        }
      }

      index++;
    }

    const documentoAgrupado = agruparRetorno<IDocumentoRetornoAilos>(documentos);
    return documentoAgrupado;
  } catch (error) {
    console.log(error);
    return null;
  }
}
